import { Icon, Table } from "simplydo/react/ui";

import type { CompanyAiService } from "components/innointel/types";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
} from "../Styles";

type CompanyServicesProps = { services: CompanyAiService[] };

const CompanyServices = ({ services }: CompanyServicesProps) => {
  if (services.length) {
    return (
      <InfoBoxWidget>
        <InfoBoxWidgetTitleArea>
          <Icon name="balance scale" />
          <div>
            <h3>Services</h3>
            <span>
              Products and/or services found from analysing the business website
            </span>
          </div>
        </InfoBoxWidgetTitleArea>
        <InfoContainer $wrapped>
          <Table definition>
            {services.map((service) => (
              <Table.Row key={service.name ?? service.description}>
                <Table.Cell collapsing>{service.name}</Table.Cell>
                <Table.Cell>{service.description}</Table.Cell>
              </Table.Row>
            ))}
          </Table>
        </InfoContainer>
      </InfoBoxWidget>
    );
  }
  return null;
};

export default CompanyServices;
